module.exports = __webpack_public_path__ + "img/black_bc.1df65ce4.jpg";